import { PromotionEditor } from './promotionEditor'
import { GolfBizNm, GolfInfoData, PromotionTitle } from '../promotionItem'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components'
import { useEffect, useRef, useState } from 'react'
import { useAxios } from '@/context/axiosContext'
import { useResponsive } from '@/hooks/useResponsive'

export const InsertPromotion = () => {
  const axios = useAxios()
  const navigate = useNavigate()
  const [nameList, setNameList] = useState<GolfBizNm[]>([])
  const { isMobile, isTablet, isDesktop } = useResponsive()
  useEffect(() => {
    getPromotionList()
  }, [])

  const getPromotionList = async () => {
    try {
      const response = await axios.get(`/promotion/getGolfNameList`, {
        headers: { 'Cache-Control': 'no-cache' },
      })

      const { golfNameList } = response.data.data

      const seenBizCds = new Set<string>()
      const nameList: GolfBizNm[] = golfNameList
        .filter((item: GolfInfoData) => {
          const isValid = item.remark?.trim()
          const isUnique = !seenBizCds.has(item.bizCd || '')

          if (isValid && isUnique) {
            seenBizCds.add(item.bizCd || '')
            return true
          }
          return false
        })
        .map((item: GolfInfoData) => ({
          areaCd: item.areaCd?.trim(),
          bizNm: item.bizNm?.trim(),
          bizCd: item.bizCd,
        }))

      setNameList(nameList) // 골프장명리스트
    } catch (err: any) {
      console.error('Error fetching List:', err)
    }
  }

  return (
    <>
      {!isMobile && (
        <div className="promo-header">
          <div className="promo-title">{PromotionTitle}</div>
          <Button
            color="neverbe"
            onClick={() => {
              setTimeout(() => {
                navigate(`/promotion`)
              }, 100)
            }}
          >
            목록
          </Button>
        </div>
      )}
      <PromotionEditor nameList={nameList} />
    </>
  )
}
